import React from 'react';
import { useTranslation } from 'react-i18next';

import '../../scss/text.scss';
import SelectField from '../../../../shared-components/select-field/SelectField';

/**
 * QR Text Component
 * @param {any} param0 - The param0
 * @param {any} param0.qrValues - The qrValues prop
 * @param {any} param0.setQrValues - The setQrValues prop
 * @returns {any} The result
 */
function Text({ qrValues, setQrValues }: any) {
  const { t } = useTranslation('qrCode');

  /**
   * Handling Font Color
   * @param {any} event - The event
   */
  const handleFontProperty = (event: any) => {
    const { name, value } = event.target;
    setQrValues((previous: any) => {
      return {
        ...previous,
        [name]: value,
      };
    });
  };

  /**
   * Handling Font Weight and Size
   * @param {any} name - The name
   * @param {any} value - The value
   */
  const handleFont = (name: string, value: string | number) => {
    setQrValues((previous: any) => {
      return {
        ...previous,
        [name]: value,
      };
    });
  };

  const fonts = [
    {
      id: 1,
      label: t('font'),
      element: (
        <SelectField
          placeholder={t('inter')}
          options={[
            { label: t('inter'), value: 'Inter' },
            { label: t('arial'), value: 'Arial' },
            { label: t('verdana'), value: 'Verdana' },
          ]}
          selectedValue={qrValues.font}
          name="font"
          onChangeValue={handleFont}
        />
      ),
    },
    {
      id: 2,
      label: t('fontWeight'),
      element: (
        <SelectField
          placeholder={t('regular')}
          options={[
            { label: t('bold'), value: 'bold' },
            { label: t('bolder'), value: 'bolder' },
            { label: t('lighter'), value: 'lighter' },
          ]}
          selectedValue={qrValues.fontWeight}
          name="fontWeight"
          onChangeValue={handleFont}
        />
      ),
    },
    {
      id: 3,
      label: t('fontColor'),
      element: (
        <input
          onChange={handleFontProperty}
          type="color"
          name="fontColor"
          value={qrValues.fontColor}
        />
      ),
    },
  ];

  return (
    <div className="text">
      {fonts.map((font) => (
        <div className="text-selection">
          <div key={font.id}>{font.label}</div>
          <div>{font.element}</div>
        </div>
      ))}
    </div>
  );
}

export default Text;
